// extracted by mini-css-extract-plugin
export default {"ul":"Products_ul__pETLv"};